import React from 'react';
import { Controller } from 'react-hook-form';
import FormControl from 'presentation/components/FormControl';
import { FormValidator } from 'tools/FormValidator';
import { useTranslation } from 'react-i18next';
import Input from 'presentation/components/Input';

interface ZipFieldProps {
  formControl: any;
  errors: any;
  setValue: (name: 'street' | 'houseNr' | 'zip' | 'city', value: any) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

/**
 * Komponente für die Eingabe der Postleitzahl als Standard-Input.
 */
const ZipField: React.FC<ZipFieldProps> = ({ formControl, errors, inputRef }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'page.houseAddress'
  });

  return (
    <FormControl
      required
      additionalTestId="zip"
      label={<span id="zip-label">{t('labelZIPCode')}</span>}
      error={errors.zip && t('errorZIPCode')}
      htmlFor="field-zip"
    >
      <Controller
        name="zip"
        control={formControl}
        rules={{
          required: true,
          validate: {
            validate: (v) => FormValidator.isValidZIPCode(v)
          }
        }}
        render={({ field }) => (
          <Input
            id="field-zip"
            type="text"
            aria-labelledby="zip-label"
            aria-required="true"
            aria-invalid={!!errors.zip}
            aria-describedby={errors.zip ? 'zip-error' : undefined}
            inputRef={inputRef}
            {...field}
          />
        )}
      />
    </FormControl>
  );
};

export default ZipField;
